import { EventEmitter, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { ILoginResponse } from '../../../modules/identity-area/auth/interface';
import { IService } from '../../interfaces/i.service.interface';
import { IUserData } from '../../interfaces/user-data.interface';
import { PlatformService } from '../platform.service';
import { TextService } from '../text.service';
import { StorageService } from '../storage.service';
@Injectable({ providedIn: 'root' })
export class AuthGuardService implements IService {
  _baseUrl = `users`;

  //Privates
  private _currentUser: IUserData | null = null;
  private _userId: string | null = null;
  // private _isLoggedIn = false;

  //#endregion

  /** To Check User If Logged In Or Not */
  isLoggedIn = signal(false); // new BehaviorSubject<boolean>(false);
  showLoginModal = signal<string | undefined>(undefined);
  loggedIn = new EventEmitter();
  onLoginFromModel = new EventEmitter();
  /** Get Current User */
  get currentUser(): IUserData {
    if (!this._currentUser) {
      this.fillCurrentUser();
    }
    return this._currentUser as IUserData;
  }

  /** Get userId */
  get userId(): string {
    if (!this._userId) {
      this.fillCurrentUser();
    }
    return this._userId as string;
  }

  constructor(
    private storage: StorageService,
    private router: Router,
    private pt: PlatformService,
    private textService: TextService
  ) {
    if (pt.isServer) return;
    this.fillCurrentUser();

    this.updateIsLoggedUser();
  }

  /** Load Current User */
  fillCurrentUser() {
    const token = this.storage.userAuth.value;
    let jwtInfo: IUserData | undefined;

    if (token) {
      jwtInfo = jwtDecode(token) as any;
    }

    if (jwtInfo) {
      this._currentUser = jwtInfo;
      this.loggedIn.emit();
    } else {
      this._currentUser = null;
    }
    this.updateIsLoggedUser();

  }

  async setUserToken(token: string, isLoginFromModal: boolean) {
    this.storage.userAuth.value = token;
    this.fillCurrentUser();
    this.updateIsLoggedUser();
    if (isLoginFromModal) {
      this.onLoginFromModel.emit(this.showLoginModal());
    }
  }

  updateIsLoggedUser() {
    try {

      this.isLoggedIn.set(this._currentUser ? true : false);
    } catch (error) {
    }
  }

  /** Log Out */
  logout(routTo: string | undefined = undefined) {
    this.storage.userAuth.delete();
    this.resetCurrentUser();
    setTimeout(() => {
      if (routTo) this.router.navigateByUrl(routTo);
    }, 0);
  }

  resetCurrentUser() {
    this._currentUser = null;
    // this._isLoggedIn = false;
    this.isLoggedIn.set(false);
    this.loggedIn.emit();
  }

  openLoginModalRequest() {
    let requestId = this.textService.generateGUID();
    this.showLoginModal.set(requestId);
    return requestId;
  }
}
